import { cleanTemplateName } from "./format.js";

const DEFAULT_FIELD_SIZE = {
  "company-seal": { width: 14, height: 14 },
  "personal-signature": { width: 18, height: 7 },
};

const VARIABLE_RULES = [
  { label: "统一信用代码", variable: "companyCreditCode", name: "统一信用代码", confidence: "high" },
  { label: "统一社会信用代码", variable: "companyCreditCode", name: "统一信用代码", confidence: "high" },
  { label: "社会统一信用代码", variable: "companyCreditCode", name: "统一信用代码", confidence: "high" },
  { label: "公司名称", variable: "companyName", name: "公司名称", confidence: "high" },
  { label: "企业名称", variable: "companyName", name: "公司名称", confidence: "high" },
  { label: "紧急联系人姓名", variable: "emergencyContactName", name: "紧急联系人姓名", confidence: "high" },
  { label: "紧急联系人关系", variable: "emergencyContactRelation", name: "紧急联系人关系", confidence: "high" },
  { label: "家属关系", variable: "emergencyContactRelation", name: "紧急联系人关系", confidence: "high" },
  { label: "员工姓名", variable: "staffName", name: "员工姓名", confidence: "high" },
  { label: "姓名", variable: "staffName", name: "员工姓名", confidence: "high" },
  { label: "证件号", variable: "idNum", name: "身份证号", confidence: "high" },
  { label: "证件号码", variable: "idNum", name: "身份证号", confidence: "high" },
  { label: "身份证号", variable: "idNum", name: "身份证号", confidence: "high" },
  { label: "身份证号码", variable: "idNum", name: "身份证号", confidence: "high" },
  { label: "出生日期", variable: "birthDate", name: "出生日期", confidence: "high", source: "derived:idNum" },
  { label: "生日日期", variable: "birthDate", name: "出生日期", confidence: "high", source: "derived:idNum" },
  { label: "证件类型", variable: "idType", name: "证件类型", confidence: "high", source: "derived:idNum" },
  { label: "性别", variable: "gender", name: "性别", confidence: "high" },
  { label: "民族", variable: "ethnicity", name: "民族", confidence: "high" },
  { label: "籍贯", variable: "nativePlace", name: "籍贯", confidence: "high", source: "derived:householdAddress" },
  { label: "户籍地址", variable: "householdAddress", name: "户籍地址", confidence: "high", source: "employee-household-address" },
  { label: "户口地址", variable: "householdAddress", name: "户籍地址", confidence: "high", source: "employee-household-address" },
  { label: "户籍所在地", variable: "householdAddress", name: "户籍地址", confidence: "high", source: "employee-household-address" },
  { label: "户口类型", variable: "householdType", name: "户口类型", confidence: "high", source: "derived:householdAddress" },
  { label: "居住地址", variable: "residentialAddress", name: "居住地址", confidence: "high", source: "roster-employee-detail:non-empty" },
  { label: "电子邮箱", variable: "email", name: "电子邮箱", confidence: "high" },
  { label: "邮箱", variable: "email", name: "电子邮箱", confidence: "high" },
  { label: "通讯地址", variable: "employeeAddress", name: "通讯地址", confidence: "high" },
  { label: "联系地址", variable: "employeeAddress", name: "通讯地址", confidence: "high" },
  { label: "职位", variable: "position", name: "职位/工作岗位", confidence: "high" },
  { label: "工作岗位", variable: "position", name: "职位/工作岗位", confidence: "high" },
  { label: "法定代表人", variable: "legalRepresentative", name: "法定代表人", confidence: "high" },
  { label: "工资方案", variable: "salaryPlan", name: "工资方案", confidence: "high" },
  { label: "工作内容", variable: "workContent", name: "工作内容", confidence: "high" },
  { label: "工伤保险", variable: "workInjuryInsurance", name: "工伤保险", confidence: "high" },
  { label: "甲方每月支付", variable: "employerMonthlyPayment", name: "甲方每月支付", confidence: "high" },
  { label: "保密类型", variable: "confidentialityType", name: "保密类型", confidence: "high" },
  { label: "保密结束日期", variable: "confidentialityEndDate", name: "保密结束日期", confidence: "high" },
  { label: "支付费用", variable: "paymentFee", name: "支付费用", confidence: "high" },
  { label: "电话", variable: "phone", name: "员工电话", confidence: "medium" },
  { label: "手机号", variable: "phone", name: "员工电话", confidence: "medium" },
  { label: "手机号码", variable: "phone", name: "员工电话", confidence: "medium" },
];

const DATABASE_MISSING_FIELD_LABELS = [
  "政治面貌",
  "婚姻状况",
  "前公司名称",
  "原公司名称",
  "前公司部门",
  "前公司职位",
  "原公司职位",
  "前公司入职时间",
  "前公司离职时间",
];

const DATABASE_MISSING_VARIABLES = [
  "politicalStatus",
  "maritalStatus",
  "previousCompanyName",
  "previousDepartment",
  "previousPosition",
  "previousOnboardingDate",
  "previousResignationDate",
];

const ALLOWED_VARIABLES = new Set(VARIABLE_RULES.map((item) => item.variable));

function stripTags(value) {
  return String(value || "").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
}

function hasVariable(value) {
  return /\{\{[^}]+\}\}/.test(String(value || ""));
}

function placeholder(variable) {
  return "{{" + variable + "}}";
}

function includesLabel(text, label) {
  return stripTags(text).replace(/\s+/g, "").includes(label);
}

function compactText(value) {
  return stripTags(value).replace(/\s+/g, "");
}

function inferSectionContext(text, currentContext = "") {
  const compact = compactText(text);
  if (!compact) return currentContext;
  if (/紧急联系人|紧急联络|紧急联系电话|家属（?紧急）?联系电话|家庭（?紧急）?联系电话/.test(compact)) {
    return "emergency";
  }
  if (/企业信息|公司信息|单位信息|用人单位|甲方信息|甲方（?用人单位）?|甲方（?保密信息披露方）?|公司名称|企业名称|法定代表人|统一社会信用代码|统一信用代码/.test(compact)) {
    return "company";
  }
  if (/员工信息|个人信息|乙方信息|乙方（?保密义务方）?|劳动者|员工姓名|姓名|身份证|性别|通讯地址|入职信息/.test(compact)) {
    return "employee";
  }
  return currentContext;
}

function resolvePhoneRule(text, sectionContext) {
  const compact = compactText(text);
  if (!/(电话|手机|联系方式|联系电话)/.test(compact)) return null;
  if (/紧急|家属|家庭|联系人/.test(compact) || sectionContext === "emergency") {
    return { label: text, variable: "emergencyContactPhone", name: "家属（紧急）联系电话", confidence: "high" };
  }
  if (/企业|公司|单位|甲方|用人单位/.test(compact) || sectionContext === "company") {
    return { label: text, variable: "companyPhone", name: "企业电话", confidence: "high" };
  }
  if (/员工|个人|乙方|劳动者|手机号码|手机号/.test(compact) || sectionContext === "employee") {
    return { label: text, variable: "phone", name: "员工电话", confidence: "high" };
  }
  return { label: text, variable: "phone", name: "员工电话", confidence: "medium" };
}

function resolveVariableRule(text, sectionContext) {
  const phoneRule = resolvePhoneRule(text, sectionContext);
  if (phoneRule) return phoneRule;
  const compact = compactText(text);
  if (sectionContext === "company" && /^名称[:：]?/.test(compact)) {
    return { label: "名称", variable: "companyName", name: "公司名称", confidence: "high" };
  }
  return VARIABLE_RULES.find((item) => includesLabel(text, item.label));
}

function isParagraphFieldAnchor(text, rule) {
  const compact = compactText(text);
  const label = String(rule?.label || "").replace(/\s+/g, "");
  if (!label) return false;
  if (compact.startsWith(label)) return true;
  return /^(甲方|乙方|公司|企业|员工|劳动者)/.test(compact)
    && compact.includes(label)
    && new RegExp(label.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "[:：]").test(compact);
}

function resolveDatabaseMissingField(text) {
  return DATABASE_MISSING_FIELD_LABELS.find((label) => includesLabel(text, label));
}

function issue(id, message, recommendation, severity = "auto-fixable", meta = {}) {
  return { id, message, recommendation, severity, ...meta };
}

function missingVariableCandidate(label, status = "database-missing") {
  return {
    label,
    status,
    message: `字段“${label}”变量库未新增。`,
    recommendation: status === "database-missing"
      ? `需先接入数据库字段和取数接口，再新增“${label}”变量。`
      : `数据库已有来源，可加入变量库后再批量插入“${label}”。`,
  };
}

function removeVariablesWithoutDatabaseSource(html) {
  let removed = 0;
  const pattern = new RegExp(
    "\\s*\\{\\{(?:" + DATABASE_MISSING_VARIABLES.map((variable) => variable.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|") + ")\\}\\}",
    "g",
  );
  const next = String(html || "").replace(pattern, (match) => {
    removed += 1;
    return /^\s+$/.test(match) ? " " : "";
  });
  return { html: next, removed };
}

function removeAllPlaceholders(value) {
  return String(value || "").replace(/\s*\{\{[^}]+\}\}/g, "");
}

function removePlaceholdersFromCell(cell) {
  return String(cell || "").replace(/(<(?:td|th)\b[^>]*>)([\s\S]*?)(<\/(?:td|th)>)/i, (_, open, body, close) =>
    `${open}${removeAllPlaceholders(body)}${close}`,
  );
}

function hasPlaceholder(value, variable) {
  return new RegExp("\\{\\{\\s*" + variable.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "\\s*\\}\\}").test(String(value || ""));
}

// 中文维护注释：批量补全变量时只保留受控变量名，避免把临时占位符写入系统模板。
function existingAllowedVariables(html) {
  return [...String(html || "").matchAll(/\{\{\s*([A-Za-z][A-Za-z0-9_]*)\s*\}\}/g)]
    .map((match) => match[1])
    .filter((variable) => ALLOWED_VARIABLES.has(variable));
}

function shouldInsertPersonalSignatureVariable(text) {
  const compact = stripTags(text).replace(/\s+/g, "");
  return /(本人|员工|乙方|填表人|承诺人|授权人|申请人).{0,8}(签名|签字|签署|捺印).{0,4}[:：]?$/.test(compact)
    || /(签名|签字|签署|捺印).{0,8}(本人|员工|乙方|填表人|承诺人|授权人|申请人).{0,4}[:：]?$/.test(compact);
}

function addInlineStyle(tag, style) {
  return tag.includes("style=")
    ? tag.replace(/style=(["'])(.*?)\1/i, (_, quote, current) => `style=${quote}${current}; ${style}${quote}`)
    : tag.replace(/>$/, ` style="${style}">`);
}

function addClass(tag, className) {
  if (tag.includes(`class="${className}`) || tag.includes(`class='${className}`)) return tag;
  return tag.includes("class=")
    ? tag.replace(/class=(["'])(.*?)\1/i, (_, quote, current) => {
        const classes = current.split(/\s+/).filter(Boolean);
        return classes.includes(className)
          ? `class=${quote}${current}${quote}`
          : `class=${quote}${[...classes, className].join(" ")}${quote}`;
      })
    : tag.replace(/>$/, ` class="${className}">`);
}

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function compactTitleText(value) {
  return stripTags(value).replace(/\s+/g, "");
}

function relatedTitleKey(candidateKey, titleKey) {
  return candidateKey
    && titleKey
    && candidateKey.length <= 60
    && (candidateKey === titleKey || candidateKey.includes(titleKey) || titleKey.includes(candidateKey));
}

function titleHeading(title, className = "") {
  const classAttr = className ? ` class="${className}"` : "";
  return `<h2${classAttr} style="text-align: center; margin: 0 0 14px; font-size: 20px; line-height: 1.45; font-weight: 700;">${escapeHtml(title)}</h2>`;
}

function removeLegacyHeadingAfterTitle(html) {
  return String(html || "").replace(
    /(<h2\b[^>]*>[\s\S]*?<\/h2>)\s*<h[1-6]\b[^>]*>\s*系统基础系统基础模板\s*<\/h[1-6]>/i,
    "$1",
  );
}

function normalizeDocumentTitle(html, templateName) {
  const title = cleanTemplateName(templateName).trim();
  if (!title) return String(html || "");
  const titleKey = compactTitleText(title);
  const heading = titleHeading(title);
  let next = String(html || "");

  const leadingBlockPattern = /^\s*<(h[1-6]|p)\b[^>]*>[\s\S]*?<\/\1>/i;
  const leadingBlock = next.match(leadingBlockPattern)?.[0] || "";
  const leadingBlockKey = compactTitleText(leadingBlock);
  if (relatedTitleKey(leadingBlockKey, titleKey)) {
    return removeLegacyHeadingAfterTitle(next.replace(leadingBlockPattern, titleHeading(stripTags(leadingBlock))));
  }

  const leadingTableTitlePattern = /^(\s*)(<table\b[^>]*>\s*)(<tr\b[^>]*>[\s\S]*?<\/tr>)/i;
  const leadingTableTitleMatch = next.match(leadingTableTitlePattern);
  const tableOpen = leadingTableTitleMatch?.[2] || "";
  const rowHtml = leadingTableTitleMatch?.[3] || "";
  if (leadingTableTitleMatch && relatedTitleKey(compactTitleText(rowHtml), titleKey)) {
    return removeLegacyHeadingAfterTitle(next.replace(leadingTableTitlePattern, `${titleHeading(stripTags(rowHtml))}${tableOpen}`));
  }

  if (compactTitleText(next.slice(0, 300)).startsWith(titleKey)) return removeLegacyHeadingAfterTitle(next);
  return removeLegacyHeadingAfterTitle(`${heading}${next}`);
}

function optimizeEditableLayout(html) {
  let next = String(html || "");
  next = next.replace(/<table\b([^>]*)>/gi, (match) =>
    addInlineStyle(match, "width: 100%; border-collapse: collapse; table-layout: fixed; page-break-inside: auto"),
  );
  next = next.replace(/<tr\b([^>]*)>/gi, (match) =>
    addInlineStyle(match, "break-inside: avoid; page-break-inside: avoid"),
  );
  next = next.replace(/<(td|th)\b([^>]*)>/gi, (match) =>
    addInlineStyle(match, "padding: 5px 7px; vertical-align: middle; word-break: break-word; line-height: 1.45"),
  );
  next = next.replace(/<p\b([^>]*)>/gi, (match) =>
    addInlineStyle(match, "margin: 0 0 6px; line-height: 1.55"),
  );
  if (!/font-family/.test(next.slice(0, 300))) {
    next = `<div style="font-family: Arial, 'Microsoft YaHei', sans-serif; font-size: 14px; line-height: 1.65; color: #111827;">${next}</div>`;
  }
  next = next.replace(/(<p[^>]*>\s*(?:&nbsp;|\s)*<\/p>\s*){3,}/gi, "<p></p>");
  return next;
}

const PAGE_BREAK_CLASS = "template-content-page-break-before";

function shouldStartNewPageTableSection(rowHtml) {
  const compact = compactText(rowHtml);
  return /^(档案文件|附件材料|归档材料|证明材料)$/.test(compact);
}

function splitTableForPageSections(tableHtml) {
  const tableOpenMatch = String(tableHtml || "").match(/^<table\b[^>]*>/i);
  const tableCloseMatch = String(tableHtml || "").match(/<\/table>\s*$/i);
  if (!tableOpenMatch || !tableCloseMatch) return { html: tableHtml, breakCount: 0 };

  const tableOpen = tableOpenMatch[0];
  const rows = [...String(tableHtml).matchAll(/<tr\b[^>]*>[\s\S]*?<\/tr>/gi)].map((match) => match[0]);
  if (!rows.length) return { html: tableHtml, breakCount: 0 };

  const chunks = [];
  let currentRows = [];
  let breakCount = 0;
  for (const row of rows) {
    if (currentRows.length && shouldStartNewPageTableSection(row)) {
      chunks.push({ rows: currentRows, pageBreakBefore: false });
      currentRows = [row];
      breakCount += 1;
      continue;
    }
    currentRows.push(row);
  }
  chunks.push({ rows: currentRows, pageBreakBefore: breakCount > 0 && chunks.length > 0 });

  if (!breakCount) return { html: tableHtml, breakCount: 0 };

  const html = chunks
    .map((chunk, index) => {
      const open = index > 0 ? addClass(tableOpen, PAGE_BREAK_CLASS) : tableOpen;
      return `${open}${chunk.rows.join("")}</table>`;
    })
    .join("");

  return { html, breakCount };
}

function splitTablesForPageSections(html) {
  let breakCount = 0;
  const next = String(html || "").replace(/<table\b[^>]*>[\s\S]*?<\/table>/gi, (table) => {
    const result = splitTableForPageSections(table);
    breakCount += result.breakCount;
    return result.html;
  });
  return { html: next, breakCount };
}

function shouldStartNewPageStandaloneTitle(blockHtml, precedingText) {
  const compact = compactText(blockHtml);
  if (!compact || compact.length > 30 || compactText(precedingText).length < 30) return false;
  return /^(入职承诺书|承诺书|诚信承诺书|入职声明|承诺函|确认书)$/.test(compact)
    || (/协议$/.test(compact) && !/信息|地址|电话|日期/.test(compact));
}

function markStandalonePageBreakTitles(html) {
  let breakCount = 0;
  const source = String(html || "");
  const next = source.replace(/<(h[1-6]|p)\b[^>]*>[\s\S]*?<\/\1>/gi, (block, _tag, offset) => {
    if (!shouldStartNewPageStandaloneTitle(block, source.slice(0, offset))) return block;
    breakCount += 1;
    // 独立文书标题从新页开始，并统一为居中 H2，避免第三页仍像普通正文段落。
    return titleHeading(stripTags(block), PAGE_BREAK_CLASS);
  });
  return { html: next, breakCount };
}

function applySmartPageBreaks(html) {
  const tableResult = splitTablesForPageSections(html);
  const headingResult = markStandalonePageBreakTitles(tableResult.html);
  return {
    html: headingResult.html,
    breakCount: tableResult.breakCount + headingResult.breakCount,
  };
}

function insertVariablesInTableRows(html) {
  const inserted = [];
  const issues = [];
  const missingVariableCandidates = [];
  const missingFieldIssues = new Set();
  let next = String(html || "");
  let sectionContext = "";

  next = next.replace(/<tr\b[^>]*>[\s\S]*?<\/tr>/gi, (row) => {
    const rowText = stripTags(row);
    sectionContext = inferSectionContext(rowText, sectionContext);
    const cells = [...row.matchAll(/<(td|th)\b[^>]*>[\s\S]*?<\/\1>/gi)];
    if (cells.length < 2) return row;
    const patchedCells = cells.map((cell) => cell[0]);

    for (let index = 0; index < cells.length - 1; index += 1) {
      const current = patchedCells[index];
      const currentText = stripTags(current);
      if (!currentText) continue;
      const target = patchedCells[index + 1];
      const missingLabel = resolveDatabaseMissingField(currentText);
      if (missingLabel) {
        if (hasVariable(target)) {
          patchedCells[index + 1] = target.replace(/(<(?:td|th)\b[^>]*>)([\s\S]*?)(<\/(?:td|th)>)/i, (_, open, body, close) =>
            `${open}${removeAllPlaceholders(body)}${close}`,
          );
        }
        if (!missingFieldIssues.has(missingLabel)) {
          missingFieldIssues.add(missingLabel);
          missingVariableCandidates.push(missingVariableCandidate(missingLabel));
          issues.push(issue(
            "variable-missing-database-source-" + missingLabel,
            `字段“${missingLabel}”未插入变量：当前数据库未配置可取数来源。`,
            `建议先在数据库和取数接口中增加“${missingLabel}”对应字段，再加入变量库；未接入前保持为空，避免生成无法填充的无效变量。`,
            "needs-confirmation",
            { label: missingLabel, source: "database-missing" },
          ));
        }
        continue;
      }
      const rule = resolveVariableRule(currentText, sectionContext);
      if (!rule) {
        continue;
      }
      if (rule.confidence !== "high") {
        issues.push(issue(
          "variable-low-confidence-" + rule.variable,
          `字段“${currentText}”可能对应 ${rule.name}，但存在同名或相近业务含义。`,
          `建议先根据所在区域确认：员工电话用 ${placeholder("phone")}，企业电话用 ${placeholder("companyPhone")}，紧急联系人电话用 ${placeholder("emergencyContactPhone")}；确认后再批量处理。`,
          "needs-confirmation",
          { variable: rule.variable, label: currentText },
        ));
        continue;
      }
      if (hasVariable(current)) {
        patchedCells[index] = removePlaceholdersFromCell(current);
      }
      if (hasPlaceholder(target, rule.variable)) continue;
      const patchedTarget = target.replace(/(<(?:td|th)\b[^>]*>)([\s\S]*?)(<\/(?:td|th)>)/i, (_, open, body, close) => {
        const cleanBody = hasVariable(body) ? removeAllPlaceholders(body) : body;
        const content = stripTags(cleanBody) ? `${cleanBody} ${placeholder(rule.variable)}` : placeholder(rule.variable);
        return `${open}${content}${close}`;
      });
      patchedCells[index + 1] = patchedTarget;
      inserted.push({ variable: rule.variable, name: rule.name, label: currentText });
    }

    let rowNext = "";
    let cursor = 0;
    cells.forEach((cell, index) => {
      rowNext += row.slice(cursor, cell.index) + patchedCells[index];
      cursor = cell.index + cell[0].length;
    });
    rowNext += row.slice(cursor);
    return rowNext;
  });

  return { html: next, inserted, issues, missingVariableCandidates };
}

function insertVariablesInParagraphs(html, alreadyInserted) {
  const inserted = [];
  let next = String(html || "");
  let sectionContext = "";
  next = next.replace(/<p\b[^>]*>[\s\S]*?<\/p>/gi, (paragraph) => {
    const text = stripTags(paragraph);
    sectionContext = inferSectionContext(text, sectionContext);
    if (hasVariable(paragraph)) return paragraph;
    if (resolveDatabaseMissingField(text)) return paragraph;
    const rule = resolveVariableRule(text, sectionContext);
    if (!rule || rule.confidence !== "high" || alreadyInserted.has(rule.variable) || !isParagraphFieldAnchor(text, rule)) return paragraph;
    inserted.push({ variable: rule.variable, name: rule.name, label: text });
    return paragraph.replace(/<\/p>$/i, ` ${placeholder(rule.variable)}</p>`);
  });
  return { html: next, inserted };
}

function insertPersonalSignatureVariables(html) {
  const inserted = [];
  const appendStaffName = (block) => {
    if (hasVariable(block) || !shouldInsertPersonalSignatureVariable(block)) return block;
    inserted.push({ variable: "staffName", name: "员工姓名", label: stripTags(block) });
    return block.replace(/(<(?:p|td|th)\b[^>]*>)([\s\S]*?)(<\/(?:p|td|th)>)/i, (_, open, body, close) =>
      `${open}${body} ${placeholder("staffName")}${close}`,
    );
  };
  let next = String(html || "");
  next = next.replace(/<(td|th)\b[^>]*>[\s\S]*?<\/\1>/gi, appendStaffName);
  next = next.replace(/<p\b[^>]*>[\s\S]*?<\/p>/gi, appendStaffName);
  return { html: next, inserted };
}

function createRole(type, index) {
  const company = type === "company";
  return {
    id: crypto.randomUUID(),
    type,
    action: company ? "company-seal" : "personal-signature",
    label: company ? "企业方" : "员工方",
    variableBinding: company ? "companyName" : "staffName",
    order: index + 1,
  };
}

function extractSignatureTextBlocks(html) {
  const source = String(html || "");
  const leafBlocks = [...source.matchAll(/<(p|td|th|li)\b[^>]*>[\s\S]*?<\/\1>/gi)]
    .map((match) => stripTags(match[0]).replace(/\s+/g, " ").trim())
    .filter(Boolean);
  if (leafBlocks.length) return leafBlocks;
  const blocks = [...source.matchAll(/<div\b[^>]*>[\s\S]*?<\/div>/gi)]
    .map((match) => stripTags(match[0]).replace(/\s+/g, " ").trim())
    .filter(Boolean);
  if (blocks.length) return blocks;
  return stripTags(source)
    .split(/[\n\r]+/)
    .map((line) => line.replace(/\s+/g, " ").trim())
    .filter(Boolean);
}

function isCompanySignatureAnchor(text) {
  const compact = compactText(text).replace(/\{\{[^}]+\}\}/g, "");
  const partyPattern = "甲方|公司|单位|用人单位|企业|发函人|被授权人|个人信息处理者|境外接收方";
  if (/^(个人信息处理者|境外接收方)[:：]?$/.test(compact)) return true;
  if (compact.length > 80 && !(new RegExp(`(${partyPattern}).{0,12}(盖章|签章|公章|签字|签名|签署).{0,4}[:：]?$`)).test(compact)) return false;
  return (new RegExp(`(${partyPattern}).{0,12}(盖章|签章|公章|签字|签名|签署)`)).test(compact)
    || (new RegExp(`(盖章|签章|公章|签字|签名|签署).{0,12}(${partyPattern})`)).test(compact);
}

function isEmployeeSignatureAnchor(text) {
  const compact = compactText(text).replace(/\{\{[^}]+\}\}/g, "");
  if (compact.length > 80 && !/(乙方|员工|劳动者|本人|申请人|承诺人|填表人|经办人|授权人).{0,12}(签字|签名|签署|捺印).{0,4}[:：]?$/.test(compact)) return false;
  return /(乙方|员工|劳动者|本人|申请人|承诺人|填表人|经办人|授权人).{0,12}(签字|签名|签署|捺印)/.test(compact)
    || /(签字|签名|签署|捺印).{0,12}(乙方|员工|劳动者|本人|申请人|承诺人|填表人|经办人|授权人)/.test(compact);
}

function detectSignatureConfig(html, pageCount) {
  const roleTypes = [];
  const addRole = (type) => {
    if (!roleTypes.includes(type)) roleTypes.push(type);
  };
  for (const block of extractSignatureTextBlocks(html)) {
    if (isCompanySignatureAnchor(block)) addRole("company");
    if (isEmployeeSignatureAnchor(block)) addRole("employee");
  }
  const roles = roleTypes.map((type, index) => createRole(type, index));
  const fieldPage = Math.max(1, Number(pageCount) || 1);
  const fields = roles.map((role, index) => {
    const size = DEFAULT_FIELD_SIZE[role.action];
    return {
      id: crypto.randomUUID(),
      roleId: role.id,
      page: fieldPage,
      x: role.type === "company" ? 12 : 58,
      y: 82,
      width: size.width,
      height: size.height,
      anchor: "manual",
      required: true,
    };
  });
  return { schemaVersion: 1, pageCount: fieldPage, roles, fields };
}

function qualityCheck({ beforeHtml, afterHtml, insertedVariables, signatureConfig, pageCount }) {
  const issues = [];
  const beforeTextLength = stripTags(beforeHtml).length;
  const afterTextLength = stripTags(afterHtml).length;
  if (beforeTextLength && afterTextLength < beforeTextLength * 0.85) {
    issues.push(issue(
      "content-shrink",
      "处理后正文长度明显减少。",
      "建议退回原正文，只执行变量扫描，不执行排版优化。",
      "manual-required",
    ));
  }
  const allowedVariables = existingAllowedVariables(afterHtml);
  if (!insertedVariables.length && !allowedVariables.length) {
    issues.push(issue(
      "no-variable-inserted",
      "未识别到可高置信插入的变量位置。",
      "建议先运行变量检查，补充字段标签与变量映射后再批量处理。",
      "needs-confirmation",
    ));
  }
  if (!signatureConfig.fields.length) {
    issues.push(issue(
      "no-signature-anchor",
      "未识别到甲方、乙方、盖章或签字位置。",
      "建议在正文签署区补充“甲方盖章”或“乙方签字”等明确锚点后重新处理。",
      "needs-confirmation",
    ));
  }
  const maxPage = Math.max(1, Number(pageCount) || 1);
  for (const field of signatureConfig.fields) {
    if (field.page < 1 || field.page > maxPage || field.x < 0 || field.y < 0 || field.x + field.width > 100 || field.y + field.height > 100) {
      issues.push(issue(
        "signature-out-of-page",
        "签章位置超出页面范围。",
        "建议按系统推荐坐标重新生成签章位置，或打开人工编辑调整该字段。",
        "manual-required",
        { fieldId: field.id },
      ));
    }
  }
  return issues;
}

export function analyzeAndEditTemplateHtml({ html, pageCount = 1, templateName = "" }) {
  const beforeHtml = String(html || "");
  const cleanupResult = removeVariablesWithoutDatabaseSource(beforeHtml);
  const tableResult = insertVariablesInTableRows(cleanupResult.html);
  const insertedSet = new Set(tableResult.inserted.map((item) => item.variable));
  const paragraphResult = insertVariablesInParagraphs(tableResult.html, insertedSet);
  const signatureVariableResult = insertPersonalSignatureVariables(paragraphResult.html);
  const insertedVariables = [...tableResult.inserted, ...paragraphResult.inserted, ...signatureVariableResult.inserted];
  const missingVariableCandidates = tableResult.missingVariableCandidates || [];
  const titledHtml = normalizeDocumentTitle(signatureVariableResult.html, templateName);
  const pageBreakResult = applySmartPageBreaks(titledHtml);
  const inferredPageCount = Math.max(1, Number(pageCount) || 1, 1 + pageBreakResult.breakCount);
  const layoutHtml = optimizeEditableLayout(pageBreakResult.html);
  const signatureConfig = detectSignatureConfig(layoutHtml, inferredPageCount);
  const issues = [
    ...(cleanupResult.removed
      ? [issue(
          "variable-removed-database-missing",
          `已清理 ${cleanupResult.removed} 个没有数据库来源的历史变量。`,
          "建议检查模板中对应字段是否确实需要自动填充；需要填充时先补数据库字段和取数接口，再加入变量库。",
          "needs-confirmation",
          { removedCount: cleanupResult.removed },
        )]
      : []),
    ...tableResult.issues,
    ...qualityCheck({
      beforeHtml: paragraphResult.html,
      afterHtml: layoutHtml,
      insertedVariables,
      signatureConfig,
      pageCount: inferredPageCount,
    }),
  ];
  const hasManualIssue = issues.some((item) => item.severity === "manual-required");
  const hasConfirmationIssue = issues.some((item) => item.severity === "needs-confirmation");
  return {
    templateName,
    status: hasManualIssue ? "manual-required" : hasConfirmationIssue ? "needs-confirmation" : "auto-completed",
    html: layoutHtml,
    insertedVariables,
    missingVariableCandidates,
    signatureConfig,
    issues,
    metrics: {
      insertedVariableCount: insertedVariables.length,
      signatureFieldCount: signatureConfig.fields.length,
      pageCount: inferredPageCount,
    },
  };
}

export function buildBatchException({ fileName = "", reason = "failed", message = "" }) {
  if (reason === "unmanaged") {
    return {
      fileName,
      status: "manual-required",
      severity: "manual-required",
      message: "该模板尚未纳管，无法直接批量编辑正文、排版和签章。",
      recommendation: "建议先导入纳管：打开该模板执行“导入当前原件”或重新上传创建草稿，纳管后再加入批量智能编辑。",
    };
  }
  if (reason === "fixed-format") {
    return {
      fileName,
      status: "manual-required",
      severity: "manual-required",
      message: "该模板当前版本不是可编辑正文格式，不能安全批量改排版。",
      recommendation: "建议先转换为可编辑正文版本；如只需要签章，可使用复制签章配置或人工定位。",
    };
  }
  if (/conflict/i.test(message)) {
    return {
      fileName,
      status: "manual-required",
      severity: "manual-required",
      message: "模板版本发生冲突，当前草稿可能已被其他操作更新。",
      recommendation: "建议点击“重新读取”后再次批量处理；系统会优先复用最新草稿。如仍冲突，打开人工编辑查看具体草稿状态。",
    };
  }
  return {
    fileName,
    status: "failed",
    severity: "manual-required",
    message: message || "批量处理失败。",
    recommendation: "建议重新读取该模板版本；若仍失败，打开单文件编辑查看具体版本状态。",
  };
}

export function summarizeBatchEditResult(results = []) {
  return {
    total: results.length,
    autoCompleted: results.filter((item) => item.status === "auto-completed").length,
    needsConfirmation: results.filter((item) => item.status === "needs-confirmation").length,
    manualRequired: results.filter((item) => item.status === "manual-required").length,
    failed: results.filter((item) => item.status === "failed").length,
  };
}
